export default {
  source: {
    url: "mapbox://mepa1363.8fl3rmz2"
  },
  layer: {
    id: "accessibility-trails",
    source: "pickyourplace_trails",
    minZoom: 5,
    maxZoom: 22,
    color: "#ffffcc"
  }
};
